import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleContent from '@/pages/blog/components/ArticleContent';
import { articles } from '@/pages/blog/data';

export default function BlogArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <Navbar />
        <main className="bg-background-50">
          <section className="w-full pt-32 md:pt-40 pb-20 md:pb-28">
            <div className="max-w-[720px] mx-auto px-6 text-center">
              <p className="font-heading text-2xl md:text-3xl text-foreground-900 mb-4">
                Artículo no encontrado
              </p>
              <p className="text-foreground-600 mb-8">
                El artículo que buscas no existe o ya no está disponible.
              </p>
              <Link
                to="/blog"
                className="inline-block px-7 py-3.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600"
              >
                Volver al blog
              </Link>
            </div>
          </section>
        </main>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <main className="bg-background-50">
        {/* Header */}
        <section className="w-full pt-28 md:pt-36 pb-8 md:pb-10">
          <div className="max-w-[820px] mx-auto px-6 md:px-8">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-foreground-800 transition-colors cursor-pointer mb-8"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line"></i>
              </span>
              <span>Volver al blog</span>
            </Link>

            <p className="text-[11px] md:text-xs tracking-[0.22em] uppercase text-accent-600 mb-5">
              {article.kicker}
            </p>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-[44px] font-semibold leading-[1.15] text-foreground-900 mb-6">
              {article.title}
            </h1>

            <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-foreground-500">
              <span className="font-medium text-foreground-700">{article.author}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300" />
              <span>{article.dateLabel}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300" />
              <span className="inline-flex items-center gap-1.5">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-time-line"></i>
                </span>
                {article.readTime} de lectura
              </span>
            </div>
          </div>
        </section>

        {/* Hero image */}
        <section className="w-full pb-10 md:pb-14">
          <div className="max-w-[1120px] mx-auto px-6 md:px-8">
            <div className="relative w-full aspect-[16/9] md:aspect-[21/9] overflow-hidden rounded-lg">
              <img
                src={article.image}
                alt={article.imageAlt}
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>
        </section>

        {/* Body */}
        <section className="w-full pb-16 md:pb-24">
          <div className="max-w-[720px] mx-auto px-6 md:px-8">
            <ArticleContent content={article.content} />

            {/* CTA */}
            <div className="mt-14 md:mt-20 border-t border-background-200 pt-10 md:pt-12">
              <div className="rounded-lg bg-background-100 border border-background-200/70 p-8 md:p-10 text-center">
                <h3 className="font-heading text-2xl md:text-3xl font-light text-foreground-900 mb-4">
                  ¿Lista o listo para ir más lejos?
                </h3>
                <p className="text-foreground-600 text-base leading-relaxed max-w-[440px] mx-auto mb-8">
                  Agenda una conversación inicial sin costo y descubre si este es tu momento.
                </p>
                <Link
                  to="/agenda"
                  className="inline-block px-8 py-3.5 rounded-full text-sm font-medium tracking-[0.03em] whitespace-nowrap transition-all duration-300 cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600"
                >
                  Agenda una sesión
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}